import { gql } from '@apollo/client';

const GET_META_GROUP = gql`
   query GetMetaGroup ($farmId: ID!){
      farmSummary (farmId: $farmId){
         ZelpAlerts{
            animalCount
            type
            newAnimalCount
            name
         }
         MyGroups{
            id
            animalCount
            type
            newAnimalCount
            name
            linkedProjects {
               id
            }
         }
         AllAnimals {
            id
            animalCount
            type
            newAnimalCount
            category
            name
         }
         AutomaticLists{
            id
            animalCount
            type
            newAnimalCount
            name
         }
         SuggestedGroups{
            name
         }
         SuggestedLists{
            name
         }
      }
      farm (id: $farmId){
         name
      }
   }
`;

export default GET_META_GROUP;
